// WARNING: This file can only be used in the client-side context, since it accesses window
import { Vector3 } from "three";
import { debounce, map } from "@/lib/utils.js";

const baseValues = {
    windowWidth: 393,
    // Put vanishing point at slightly top, right
    vanishingPoint: [3, 9, -50],
    // radius: 0.5,
    // angle: Math.PI + Math.PI / 2.8,
};
const endValues = {
    windowWidth: 1920,
    vanishingPoint: [15, 9, -50],
    // radius: 1,
    // angle: Math.PI + Math.PI / 6,
};
const windowWidth = ref(baseValues.windowWidth);

// Reactive configs
const configs = computed(() => ({
    vanishingPoint: new Vector3(
        mapWindowScale(
            baseValues.vanishingPoint[0],
            endValues.vanishingPoint[0],
        ),
        baseValues.vanishingPoint[1],
        baseValues.vanishingPoint[2],
    ),
    // Refer to vanishing point in xy plane, move camera up, right to create skewed perspective
    cameraPosition: new Vector3(
        mapWindowScale(
            baseValues.vanishingPoint[0],
            endValues.vanishingPoint[0],
        ) * 1.2,
        baseValues.vanishingPoint[1] * 1.2,
        0,
    ),
    // Look at the vanishing point projection on the Z axis, this create the skew perspective, which makes vanishing point top-right
    cameraLookAt: new Vector3(0, 0, baseValues.vanishingPoint[2]),
    zoomFactor: mapWindowScale(13.5, 5.8),
    textScaleFactor: mapWindowScale(0.5, 0.2),
}));

// Helpers
// Calculate values based on viewport width
function mapWindowScale(baseValue, endValue) {
    const mapped = map(
        windowWidth.value,
        baseValues.windowWidth,
        endValues.windowWidth,
        baseValue,
        endValue,
    );
    // If decreasing (baseValue > endValue)
    if (baseValue > endValue) {
        return Math.max(Math.min(mapped, baseValue), endValue);
    }
    // If increasing (baseValue < endValue)
    else {
        return Math.min(Math.max(mapped, baseValue), endValue);
    }
}

function handleResize() {
    debounce(() => {
        if (typeof window !== "undefined") {
            windowWidth.value = window.innerWidth;
        }
    })();
}

export function useExperience() {
    return {
        configs,
        handleResize,
        mapWindowScale,
    };
}
